import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/unit-types/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/unit-types/delete`,
        endpoint: `${endpointBackend}gci/unit-types/getall`
    }

    let list = {
        labelTitle: 'Lista de Tipos de Unidade',
        labelTitleButtonAdd: 'Incluir novo tipo de unidade',
        fieldsShowOnDelete: ['unit_type'],
        columns: [
            {
                name: 'unit_type',
                label: 'Tipo de Unidade',
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
